import { render, staticRenderFns } from "./PxSituacaoAdmin.vue?vue&type=template&id=3e25de3e"
import script from "./PxSituacaoAdmin.vue?vue&type=script&lang=js"
export * from "./PxSituacaoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports